<template>
  <dx-popup
    v-model:visible="popupVisible"
    :drag-enabled="true"
    :hide-on-outside-click="false"
    :min-width="500"
    :show-close-button="true"
    :show-title="true"
    :title="popupTitle"
    :height="popupHeight"
    :resize-enabled="true"
    shading-color="rgba(0,0,0,0.05)"
    :width="popupWidth"
  >
    <div class="h-100 d-flex flex-column">
      <dx-data-grid
        v-if="popupVisible"
        :allow-column-reordering="true"
        :column-chooser="{ enabled: true, mode: 'select' }"
        :column-min-width="50"
        :columns="columns"
        :data-source="dataSource"
        :filter-panel="{ visible: true }"
        :filter-row="{ visible: true }"
        :header-filter="{ visible: true }"
        :height="50"
        :hover-state-enabled="true"
        :remote-operations="{ filtering: true, paging: true, sorting: true, summary: true }"
        :row-alternation-enabled="true"
        :show-borders="true"
        :show-column-lines="true"
        :width="'100%'"
        :word-wrap-enabled="true"
        class="flex-grow-1"
        @toolbar-preparing="onToolbarPreparing($event)"
        @selection-changed="selectionChanged($event)"
      >
        <dx-paging :enabled="true" :page-size="30" />
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />
        <dx-selection
          :mode="selectionMode"
        />

        <dx-summary v-if="showSummary">
          <dx-total-item
            v-for="(item) in summaryColumns"
            :key="item.dataField"
            :column="item.dataField"
            :name="item.dataField"
            :show-in-column="item.dataField"
            :value-format="item.format"
            display-format="{0}"
            :summary-type="item.summary"
          />
        </dx-summary>

      </dx-data-grid>

      <footer-grid :totalCount="totalCount" class="px-2"></footer-grid>
    </div>
  </dx-popup>
</template>

<script>
export default {
  name: 'mped-popup-grid-view',
};
</script>

<script setup>
import { defineExpose, ref, defineEmits, defineProps, onBeforeMount } from 'vue';

import {
  DxDataGrid,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxExport,
  DxPaging,
  DxSelection,
  DxSummary,
  DxTotalItem,
} from 'devextreme-vue/data-grid';
import { DxPopup } from 'devextreme-vue/popup';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';

const popupVisible = ref(false);

const emit = defineEmits(['selectedItem']);

const { chooseItem, selectionMode, fnGetData, columns, popupTitle, defaultFilter, popupHeight, showSummary } = defineProps({
  chooseItem: {
    type: Boolean,
    default: false,
  },
  selectionMode: {
    type: String,
    default: 'single',
  },
  fnGetData: {
    type: Function,
  },
  columns: {
    type: Array,
  },
  popupTitle: {
    type: String,
  },
  defaultFilter: {
    type: Array,
    default: () => [],
  },
  popupHeight: {
    type: String,
    default: '90vh',
  },
  popupWidth: {
    type: String,
    default: '80vw',
  },
  showSummary: {
    type: Boolean,
    default: false,
  }
});

const dataSource = getAiDataSource(
  {
    dataFn: fnGetData,
    key: 'id',
    remoteOperation: true,
    onLoadedFn: (data) => {
      totalCount.value = data.totalCount;
    },
    customFilterFn: () => defaultFilter,
    paramsFn: () => {
      if (customParams)
        return customParams;
    },
  },
);

const
  totalCount = ref(0),
  summaryColumns = ref([]);

let
  selectedRowsData = [],
  toolbarButtons = {},
  customParams = null;

onBeforeMount(() => {
  function flatColumns(items, total = []) {
    for (let item of items) {
      total.push(item);
      if (item.columns && Array.isArray(item.columns)) {
        flatColumns(item.columns, total);
      }
    }
    return total;
  }

  if (showSummary) {
    summaryColumns.value = flatColumns(columns).filter(c => c.summary);
    console.log(summaryColumns);
  }
});

const onToolbarPreparing = (e) => {
  toolbarButtons = getAiToolbar(e, {
    refresh: {
      event: reloadData,
    },
    ...(chooseItem && { check: { event: selectedItems } } || {}),
  });
};

const reloadData = () => {
  dataSource.reload();
};

const Open = (options) => {
  popupVisible.value = true;
  customParams = options?.params;
};

const selectedItems = (e) => {
  emit('selectedItem', selectionMode === 'single' && selectedRowsData[0] || selectedRowsData);

  if (selectionMode === 'single') {
    popupVisible.value = false;
  }
};

const selectionChanged = (e) => {
  selectedRowsData = e.selectedRowsData;
  if (toolbarButtons.check) {
    toolbarButtons.check.option({ disabled: !selectedRowsData.length });
  }
};


defineExpose({
  Open,
});

</script>

<style scoped>

</style>
